import type { ErpModule } from '@/api/platform.api';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { isPlatformAdminRoute } from '@/config/moduleDefaults';

/** API `module` query — omit on cross-module org admin routes. */
export function resolveNotificationModuleParam(
  pathname: string,
  activeModule: ErpModule | null,
): ErpModule | undefined {
  if (isPlatformAdminRoute(pathname)) return undefined;
  return activeModule ?? undefined;
}

export function notificationPanelTitle(module: ErpModule | undefined): string {
  if (!module) return 'Notifications';
  const label = getModuleEntryByErpModule(module)?.label ?? module;
  return `${label} notifications`;
}
